var modules_1e75be7a = {"container":"Bottom_module_container__0d47dc28","bottom-block":"Bottom_module_bottomBlock__0d47dc28","bottom-block__wrapper":"Bottom_module_bottomBlock__wrapper__0d47dc28","bottom-block__left":"Bottom_module_bottomBlock__left__0d47dc28","bottom-block__right":"Bottom_module_bottomBlock__right__0d47dc28"};
import "../../assets/w8bWvtZZ.css";

export { modules_1e75be7a as default };
//# sourceMappingURL=Bottom.module.less.js.map
